import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { onMounted, ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentAttachmentModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  urlAttachment: {
    type: String,
    default: "",
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;



const showRef = ref(props.show);
const isModalImgShown = ref(false);
const styleClass = { background: "rgba(0, 0, 0, 0.5)", top: "0px" };

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const closeModalImg = () => {
  isModalImgShown.value = false;
  handleCloseModal();
};

const initial = () => {
  isModalImgShown.value = true;
};

onMounted(() => initial());

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": showRef.value,
    close: closeModalImg,
    "style-class": styleClass
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: __props.urlAttachment,
        style: {"object-fit":"contain","width":"100%","height":"100%"},
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})